import * as t from 'io-ts';

import {makeSafeArrayType} from '../../types/arrayTypes';
import {makeDefaultValueType} from '../../types/defaultValueType';
import {makeStrictEnumRuntimeType} from '../../types/enumTypes';
import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

const defaultTimeWindow = 3 * 24 * 60 * 60 * 1000; // 3 days in milliseconds
export const defaultMobilePrefetcherConfig = {
  ...defaultLastWriterWinsValue,
  enabled: false,
  timeWindow: defaultTimeWindow,
  options: [],
};

export enum MobilePrefetcherOptionsEnum {
  ALLOW_CELLULAR = 'ALLOW_CELLULAR',
}

const RMobilePrefetcherOptionsEnum = makeStrictEnumRuntimeType(MobilePrefetcherOptionsEnum);

export const RMobilePrefetcherConfig = t.intersection([
  RLastWriterWinsValue,
  t.type({
    enabled: t.boolean,
    timeWindow: t.number,
    options: makeDefaultValueType(makeSafeArrayType(RMobilePrefetcherOptionsEnum), []),
  }),
]);

export type MobilePrefetcherConfig = t.TypeOf<typeof RMobilePrefetcherConfig>;

/*
 * Helpers.
 */

export function isCellularAllowed(prefetcherConfig: MobilePrefetcherConfig) {
  return prefetcherConfig.options.includes(MobilePrefetcherOptionsEnum.ALLOW_CELLULAR);
}

/*
 * Conflict resolution.
 */

export const mergeMobilePrefetcherConfig: (
  left: MobilePrefetcherConfig,
  right: MobilePrefetcherConfig,
) => MobilePrefetcherConfig = mergeLastWriterWinsValue;
